import { defineStore } from 'pinia';
import Network from "~/utils/network";

const urls = {
    specialFieldWithId: (id) => `/administration/special-field/${id}`,
};

export const useSpecialFieldStore = defineStore('specialField', {
    state: () => ({ specialFieldData: {} }),
    actions: {
        fetchOne: async function (id) {
            try {
                let data = await Network.http(urls.specialFieldWithId(id));
                this.saveOne(data);
            } catch (err) {
                console.log(err);
                await Promise.reject(err);
            }
        },
        setCompletedLocally: function (fieldId) {
            this.setCompleted(fieldId);
        },
        saveOne: function (data) {
            this.specialFieldData[data.id] = data;
        },
        setCompleted: function (fieldId) {
            this.specialFieldData[fieldId].completed = true;
        },
    },
});
